import { Structure as CoreStructure } from '@portal-internet/components';
import { useRouter } from 'next/router';
import { useRedlMetadata } from 'hooks/useRedlMetadata';

export default function Structure(structureProps) {
    const router = useRouter();
    const { setRedlNotRenderableInfo } = useRedlMetadata(router.pathname);

    const setNotRenderableInfo = (dataId, rootIndex, componentName, blocIdx) => {
        setRedlNotRenderableInfo(dataId, rootIndex, componentName, blocIdx);
    };

    const structurePropsEx = { ...structureProps, setNotRenderableInfo };
    return <CoreStructure {...structurePropsEx} />;
}
